/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_AltInputs */

const en_marketing_app_anna_alt = /** @type {(inputs: Marketing_App_Anna_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna V. review`)
};

const es_marketing_app_anna_alt = /** @type {(inputs: Marketing_App_Anna_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseña de Anna V.`)
};

/**
* | output |
* | --- |
* | "Anna V. review" |
*
* @param {Marketing_App_Anna_AltInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_alt = /** @type {((inputs?: Marketing_App_Anna_AltInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_AltInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_alt(inputs)
	return en_marketing_app_anna_alt(inputs)
});